import { render } from "./QuickpayPaymentLayout.vue?vue&type=template&id=f8dfa06a&scoped=true"
const script = {}

import "./QuickpayPaymentLayout.vue?vue&type=style&index=0&id=f8dfa06a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8dfa06a"]])

export default __exports__